import React from "react";
import "./../../A2Page/A2Page.css"

const B1WhyHead = () => {
  return (
    <div className="a2WhyHeadContainer">
      <h2>
        B1 <span>German Classes</span> in Bangalore at Prizma Academy
      </h2>
      <p>
        At Prizma Academy, we understand that language learning is more than At
        Prizma Academy, we understand that mastering a new language requires
        more than just classroom instruction. Our B1 German Classes in Bangalore
        focus on real-world applications, cultural immersion, and interactive
        learning to ensure you gain a comprehensive understanding of the
        language. Here are some reasons to choose our B1 German Classes in
        Bangalore:
      </p>
    </div>
  );
};

export default B1WhyHead;
